import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
import {Helmet} from "react-helmet";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import configVars from "../config";
import TeamBars from "../partials/Dashboard/Charts/TeamBars";
import OfflineColumnChart from "../partials/HVI/OfflineColumnChart";
import OfflinePieChart from "../partials/HVI/OfflinePieChart";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";

const OfflineHVIResults = (props) => {

    const { company } = useParams();
    const [graphData, setGraphData] = useState({});
    const [average, setAverage] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(false);
    const [redPeople, setRedPeople] = useState(0);
    const [yellowOnePeople, setYellowOnePeople] = useState(0);
    const [yellowTwoPeople, setYellowTwoPeople] = useState(0);
    const [greenPeople, setGreenPeople] = useState(0);

    const [translation] = useTranslation("translations");
	const [cookies] = useCookies(["sc_user_lang"]);

    //const [userLang, setUserLang] = useState('sv');
    const [questions, setQuestions] = useState([]);

    useEffect(() => {

		const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);

		const chosenLang = urlParams.get("lang");
    	const savedLang = cookies?.sc_user_lang;

        let cur_lng = 'sv';

		if ( chosenLang ) {
            cur_lng = chosenLang;
		} else if ( savedLang ) {
            cur_lng = savedLang;
		}

        if ( props.questions && props.questions.length > 0 ) {
            setQuestions( props.questions );
        } else {

            let qs = [
                'Meningsfullhet i vardagen',
                'Kontroll över vardagsstressen',
                'Tillräckligt med återhämtning',
                'Tillräckligt med sömn',
                'Balans mellan krav och resurser på jobbet',
                'Balans mellan krav och resurser hemma',
                'Ork på jobbet',
                'Ork hemma',
                'Nöjd med arbetsinsatsen',
                'Nöjd med fritiden',
                'Kan koppla bort jobbet när man är ledig',
                'Kan koppla bort privata frågor när man jobbar'
            ];
        
            if ( cur_lng && cur_lng === 'en' ) {
                qs = [
                    'Meaningfulness in everyday life',
                    'Control over everyday stress',
                    'Sufficient recovery',
                    'Sufficient sleep',
                    'Balance between demands and resources at work',
                    'Balance between demands and resources at home',
                    'Energy at work',
                    'Energy at home',
                    'Satisfied with work effort',
                    'Happy with free time',
                    'Can switch off work when free',
                    'Can put private matters aside when working'
                ];
            }

            setQuestions( qs );

        }

	}, [cookies.sc_user_lang, props.questions]);

    useEffect(() => {

        setLoading(true);

        (async () => {

            let apiLink = `${configVars.apiUrl}sustainchange/v1/getofflinehvi/?company=${company}`;

            if ( props.apiLink ) {
                apiLink = props.apiLink;
            }
				
            const response = await fetch(
                apiLink,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                }
            );
            
            const hviResponse = await response.json();

            if ( hviResponse ) {

                if ( hviResponse.success === true ) {

                    let hviData = hviResponse.data.company_hvi;
                    let teamHvi = {
                        red: [0,0,0,0,0,0,0,0,0,0,0,0],
                        yellow: [0,0,0,0,0,0,0,0,0,0,0,0],
                        green: [0,0,0,0,0,0,0,0,0,0,0,0]
                    };

                    setTotalUsers( hviData.length );

                    let red = 0;
                    let yellowOne = 0;
                    let yellowTwo = 0;
                    let green = 0;

                    hviData.map( ( userData ) => {

                        let totalPoints = 0;

                        userData.map( (value, index ) => {

                            totalPoints = totalPoints + value;

                            if ( value === 0 || value === 1 || value === 2 ) {
        
                                teamHvi.red[index] = teamHvi.red[index] + 1;
                            }
            
                            if ( value === 3 || value === 4 ) {
            
                                teamHvi.yellow[index] = teamHvi.yellow[index] + 1;
                            }
            
                            if ( value === 5 || value === 6 ) {
            
                                teamHvi.green[index] = teamHvi.green[index] + 1;
                            }
                
                            return value;

                        });

                        if ( totalPoints > 12 && totalPoints <= 24 ) {
                            red = red + 1;
                        }

                        if ( totalPoints > 24 &&  totalPoints <= 41 ) {
                            yellowOne = yellowOne + 1; 
                        }

                        if ( totalPoints >= 60 ) {
                            green = green + 1;
                        }

                        if ( totalPoints >= 42 &&  totalPoints <= 59 ) {
                            yellowTwo = yellowTwo + 1;
                        }

                        return userData;
                        
                    });

                    teamHvi.red.map( (hvival, index) => (
                        teamHvi.red[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));
                    teamHvi.yellow.map( (hvival, index) => (
                        teamHvi.yellow[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));
                    teamHvi.green.map( (hvival, index) => (
                        teamHvi.green[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));

                    setGraphData( teamHvi );
                    setAverage( hviResponse.data.hvi_average );

                    setRedPeople( red );
                    setYellowOnePeople( yellowOne );
                    setGreenPeople( green );
                    setYellowTwoPeople( yellowTwo );

                    //console.log( hviData );
                    //console.log( teamHvi );

                }

                //console.log( hviResponse.data );

            }

            setLoading(false);

        })()

    }, [company, props.apiLink]);

    const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

    return (
        <div className="main-wrapper">
			<Helmet>
				<title>{ props.titleOne ? props.titleOne : translation('hvi_title')}</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title={translation("welcome")} />
				
				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">{ props.titleOne ? props.titleOne : translation('hvi_title')}</h1>
						</div>
					</div>

						<div className="px-4" style={{maxWidth: '1400px'}}>
                            <div className="hvi-wrap mt-5 d-flex align-items-center">
                                <span className="h5 me-2">{ props.titleTwo ? props.titleTwo : `Team HVI (medelvärde)`}:</span>
                                <span className={`text-white h5 py-3 px-4 bg-${getHviColor(average)}`}>{average}</span>
                            </div>
                            <div className="hvi-wrap mt-3 d-flex align-items-center">
                                <span className="h5 me-2">Totalt antal som svarat:</span>
                                <span className="h5">{totalUsers}</span>
                            </div>
                            <div className="hvi-wrap mt-3">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <OfflineColumnChart totalUsers={totalUsers} data={[redPeople, yellowOnePeople, yellowTwoPeople, greenPeople]} title={props.titleFour} />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <OfflinePieChart totalUsers={totalUsers} data={[redPeople, yellowOnePeople, yellowTwoPeople, greenPeople]} title={props.titleFive} />
                                    </div>
                                </div>
                            </div>
							<div className="hvi-wrap mt-5">
                                <TeamBars hviValues={graphData} loading={loading}
                                title={ props.titleThree ? props.titleThree : 'Team HVI - fördelning per fråga' }
                                questions={questions} />
							</div>
						</div>
				</div>

			</div>
		</div>
    );
}

export default OfflineHVIResults